var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersGrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8484 9.44961C17.8484 11.0236 16.5725 12.2996 14.9984 12.2996C13.4244 12.2996 12.1484 11.0236 12.1484 9.44961C12.1484 7.87559 13.4244 6.59961 14.9984 6.59961C16.5725 6.59961 17.8484 7.87559 17.8484 9.44961Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7008 19.5296C20.7008 21.6896 18.1484 23.45 15.0008 23.45C11.8532 23.45 9.30078 21.6944 9.30078 19.5296C9.30078 17.3648 11.8532 15.6104 15.0008 15.6104C18.1484 15.6104 20.7008 17.3648 20.7008 19.5296Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8808 12.0639C23.8929 12.758 23.4842 13.3908 22.8462 13.6649C22.2083 13.9391 21.4679 13.8002 20.9726 13.3136C20.4773 12.827 20.3254 12.0893 20.5882 11.4466C20.8511 10.8039 21.4764 10.384 22.1708 10.3839C23.1068 10.3759 23.8721 11.1279 23.8808 12.0639Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12136 12.0639C6.10918 12.758 6.51799 13.3908 7.15591 13.6649C7.79385 13.9391 8.53421 13.8002 9.02951 13.3136C9.5248 12.827 9.67668 12.0893 9.41386 11.4466C9.15105 10.8039 8.5257 10.384 7.83136 10.3839C6.89536 10.3759 6.12994 11.1279 6.12136 12.0639Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0595 21.4342C22.5644 21.3898 22.1271 21.7552 22.0828 22.2503C22.0384 22.7455 22.4038 23.1827 22.8989 23.227L23.0595 21.4342ZM26.3992 19.5298L27.2938 19.6279C27.301 19.5626 27.301 19.4967 27.2938 19.4314L26.3992 19.5298ZM22.8989 15.8338C22.4038 15.8781 22.0384 16.3154 22.0828 16.8105C22.1271 17.3056 22.5645 17.671 23.0595 17.6266L22.8989 15.8338ZM7.09949 23.227C7.59456 23.1827 7.95996 22.7455 7.91563 22.2503C7.87131 21.7552 7.43403 21.3898 6.93895 21.4342L7.09949 23.227ZM3.59922 19.5298L2.70461 19.4314C2.69743 19.4967 2.69742 19.5626 2.70457 19.6279L3.59922 19.5298ZM6.93892 17.6266C7.43399 17.671 7.87128 17.3056 7.91563 16.8105C7.95999 16.3154 7.5946 15.8781 7.09953 15.8338L6.93892 17.6266ZM22.8989 23.227C25.0995 23.4241 27.0532 21.8241 27.2938 19.6279L25.5046 19.4318C25.3707 20.6536 24.2837 21.5438 23.0595 21.4342L22.8989 23.227ZM27.2938 19.4314C27.0525 17.2358 25.099 15.6367 22.8989 15.8338L23.0595 17.6266C24.2835 17.5169 25.3703 18.4066 25.5046 19.6281L27.2938 19.4314ZM6.93895 21.4342C5.71467 21.5438 4.62773 20.6536 4.49387 19.4318L2.70457 19.6279C2.94517 21.8241 4.89889 23.4241 7.09949 23.227L6.93895 21.4342ZM4.49383 19.6281C4.62813 18.4066 5.71493 17.5169 6.93892 17.6266L7.09953 15.8338C4.89947 15.6367 2.94599 17.2358 2.70461 19.4314L4.49383 19.6281Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGrp);
export default __webpack_public_path__ + "static/media/users-grp.f541e04102a5459427c8895dce246c2b.svg";
export { ForwardRef as ReactComponent };